import { MijnRoute } from '../mijn-navigatie.model';

export const SORRY: MijnRoute = {
    path: 'helaas',
    navigationEvent: 'toHelaas',
    regex: /^\/helaas$/
};
